import { ReactNode } from 'react';
import { Typography, IconButton } from '@mui/material';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import { StyledHeader } from './Styledheader';

type NewHeaderPropsType = {
  title?: string;
  actionSlot?: ReactNode;
};

export const NewHeader = ({ title, actionSlot }: NewHeaderPropsType) => {
  const handleLogOut = () => {
    localStorage.setItem('access_token', '');
    window.location.href = '/auth';
  };

  return (
    <StyledHeader>
      <div className="title">
        <Typography
          variant="h5"
          sx={{ fontWeight: '600' }}
        >
          {title ?? '---'}
        </Typography>
      </div>
      <div className="actions">
        {actionSlot}
        <IconButton>
          <NotificationsNoneOutlinedIcon />
        </IconButton>
        <IconButton onClick={handleLogOut}>
          <LogoutIcon />
        </IconButton>
      </div>
    </StyledHeader>
  );
};
